import React, { useEffect, useState } from 'react';
import { fetchTaskAttachmentBlob } from '../../utils/taskAttachment';

/**
 * Renders an image from GET /api/task/attachments/:id with Bearer auth (via axios).
 */
export default function TaskAttachmentImage({
  fileId,
  alt = '',
  style = {},
  className = '',
  onClick,
}) {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let objectUrl = null;

    (async () => {
      try {
        const blob = await fetchTaskAttachmentBlob(fileId);
        objectUrl = URL.createObjectURL(blob);
        if (!cancelled) setSrc(objectUrl);
      } catch (e) {
        if (!cancelled) setFailed(true);
      }
    })();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [fileId]);

  if (failed) {
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#eee',
          color: '#666',
          fontSize: 11,
        }}
        title="Could not load attachment"
      >
        Preview unavailable
      </div>
    );
  }

  if (!src) {
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f3f4f6',
          fontSize: 11,
          color: '#888',
        }}
      >
        …
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      style={style}
      className={className}
      onClick={onClick}
    />
  );
}
